import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React, { useState } from 'react';

import { ErrorMessage } from 'src/components/errorMessage/ErrorMessage';

import { UploadAvatar } from './UploadAvatar';

export const AvatarModal = ({
  isOpen,
  title,
  refreshAvatar,
  onClose,
  avatarUploadUrl,
  avatarUploadToken,
}: {
  isOpen: boolean;
  title?: React.ReactNode;
  onClose: () => void;
  refreshAvatar: () => void;
  avatarUploadUrl: string;
  avatarUploadToken: string;
}) => {
  const [file, setFile] = useState<File>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{title ?? 'Update Avatar'}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <UploadAvatar
            onUpdate={(f) => {
              if (f) setFile(f);
            }}
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              variant="secondary"
              isDisabled={loading}
              onClick={onClose}
              type="button"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              isLoading={loading}
              loadingText="Update image"
              type="submit"
              onClick={() => {
                if (file) {
                  setLoading(true);
                  fetch(avatarUploadUrl, {
                    method: 'PUT',
                    body: file,
                    credentials: 'include',
                    headers: {
                      'x-apollo-csrf-token': avatarUploadToken,
                      'x-apollo-content-filename': file.name,
                      'Content-Type': file.type,
                    },
                  })
                    .then((response) => {
                      if (response.ok) {
                        refreshAvatar();
                        setLoading(false);
                        onClose();
                      } else {
                        setLoading(false);
                        setError(
                          response.status === 413
                            ? 'Your file is too large, please try a smaller image'
                            : `There was an issue uploading your file. Status code ${response.status}`,
                        );
                      }
                    })
                    .catch((e) => {
                      setLoading(false);
                      setError(e.message);
                    });
                }
              }}
            >
              Update image
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
